<template>
  <div class="tabs-container">
    <div
      v-for="(item, index) in list"
      :class="{active: index === tabActive}"
      :key="index"
      @click="tabClick(index)">
      {{item.title}}
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tabActive: parseInt(this.$route.query.tab) || 0
    }
  },

  methods: {
    tabClick(index) {
      this.tabActive = index
      this.$emit('index-click', index)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .tabs-container
    display flex
    align-items center
    justify-content space-between
    padding 0 64px
    min-height 40px
    line-height 40px
    border-bottom #EBEBEB
    box-shadow 0px 1px 0px 0px rgba(235,235,235,1)
    > div
        white-space nowrap
        &.active
          position relative
          font-size 16px
          font-weight 500
          color #F43737
          &:after
            content ''
            position absolute
            width 20px
            height 2px
            background #F43737
            bottom 0
            left 50%
            margin-left -10px

</style>